// Author YuJiaBei
// Date 2022-12-12 10:00:40

import * as model from "@/model/em/maintenance/EmMaMaintenanceWoModel.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.EmMaMaintenanceWo(), newFilter)
    .withStates({
        baseModuleUrl: process.env.VUE_APP_EM_MAINTENANCE_URL,
        callbackApi: process.env.VUE_APP_EM_MAINTENANCE_URL + '/emMaMaintenanceWo/complete-feedback',
        processDefinitionKey: "em_ma_maintenance_work_order",
        processBusinessData: Object
    })
    .withMutations({
        setProcessBusinessData(state, data) {
            state.processBusinessData = data
        }
    })
    .buildStore()
